import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {BaseMessage, ToolMessage} from '@langchain/core/messages';
import {AssetComponent} from '@components/mainmenu/reports-menu/ai-reports/ai-reports-sub-menu/asset/asset.component';
import {AiChatFacade} from '../../ai-chat.facade';
import {ToolArtifact} from "@models/ai-reports/shared/artifact";

@Component({
  selector: 'app-chat-message-artifact',
  standalone: true,
  imports: [AssetComponent],
  templateUrl: './chat-message-artifact.component.html',
  styleUrl: './chat-message-artifact.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatMessageArtifactComponent {
  readonly message = input.required<BaseMessage>();
  protected readonly facade = inject(AiChatFacade);

  private readonly artifact = computed(() => {
    const msg = this.message();
    if (ToolMessage.isInstance(msg)) {
      return msg.artifact;
    }
    return null;
  });

  readonly assets = computed(() => {
    const artifact: ToolArtifact = this.artifact();
    return artifact?.assets ?? [];
  });
}
